import { useEffect, useState } from "react"
import { BrowserRouter, Navigate, useLocation } from "react-router-dom"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import App from "./App"
import LiveChat from "./modules/LiveChat"
import ReactDOM from "react-dom/client"
import TopHeaderNav from "./modules/snippets/TopHeaderNav"
import ModulesPeraBayong from "./modules/promotions/promotion_modules/modules_peraBayong"
import MainNav from "./modules/snippets/MainNav"
import SideContainer from "./modules/snippets/SideContainer"
import Footer from "./modules/Footer"
import FeaturedPromoMobile from "./modules/snippets/FeaturedPromoMobile"
import { GlobalProvider, useGlobalContext } from "./modules/data/GlobalContext"
import { LeaderboardProvider } from "./modules/data/LeaderboardProvider"
import { LeaderboardProviderCQ9 } from "./modules/data/LeaderboardProviderCQ9"
import { LeaderboardProviderJDB } from "./modules/data/LeaderboardProviderJDB"
import { LeaderboardProviderPP } from "./modules/data/LeaderboardProviderPP"
import SearchGamesLibrary from "./modules/snippets/global_functions/SearchGamesLibrary"
import { apiJSONURL } from "./App"
import { handleLogout } from "./modules/snippets/Logout"
import BNGBetRace from "./modules/promotions/BNGBetRace"

// Stylesheets
import "./style/style.css"
import "./style/fonts.css"
import "./style/mobile.css"
import "./style/animation.css"
import "./style/variables.css"
import "./style/christmas.css"

// Modules & Pages
import SlotsGames from "./modules/pages/SlotsGames"
import Profile from "./modules/profile/Profile"
import Promotions from "./modules/promotions/Promotions"
import RaceToRiches from "./modules/promotions/RaceToRiches"
import ExlusiveVIPRollingCommission from "./modules/promotions/ExlusiveVIPRollingCommission"
import LotteryDraw from "./modules/promotions/LotteryDraw"
import PeraOBayong from "./modules/promotions/PeraOBayong"
import PragmaticDailyWins2025 from "./modules/promotions/PragmaticDailyWins2025"
import NewMemberPackageBonus from "./modules/promotions/NewMemberPackageBonus"
import ThirdTimeACharm from "./modules/promotions/ThirdTimeACharm"
import BecomeAgentMonthlyCommission from "./modules/promotions/BecomeAgentMonthlyCommission"
import VVIPWeeklyRewards from "./modules/promotions/VVIPWeeklyRewards"
import VIPReferralProgram from "./modules/promotions/VIPReferralProgram"
import WeeklyCashback from "./modules/promotions/WeeklyCashback"
import BirthdayBonus from "./modules/promotions/BirthdayBonus"
import PaydayBonus from "./modules/promotions/PaydayBonus"
import LiveGamesPage from "./modules/pages/LiveGamesPage"
import VipLevels from "./modules/pages/VipLevels"
import TNC from "./modules/TNC"
import EasterEggBunny from "./modules/snippets/games/EasterEggBunny"
import NotFound from "./modules/NotFound"
import SpinSurprize from "./modules/promotions/SpinSurprize"
import EasterEgg from "./modules/promotions/EasterEgg"
import ResponsibleGaming from "./modules/ResponsibleGaming"
import Sportsbookpage from "./modules/pages/Sportsbookpage"
import DailyWins from "./modules/promotions/DailyWins"
import AboutUs from "./modules/AboutUs"
import DownloadApp from "./modules/DownloadApp"
import DoubleUp from "./modules/promotions/DoubleUp"
import CQ9Gaming from "./modules/promotions/CQ9Gaming"
import JDBExclusivePromo from "./modules/promotions/JDBExclusivePromo"
import BETSOFTLuckyWheel from "./modules/promotions/BETSOFTLuckyWheel"
import FGHSignUpTreat from "./modules/promotions/FGHSignUpTreat"
import PragmaticPlayDaily from "./modules/promotions/PragmaticPlayDaily"
import TPGGames from "./modules/promotions/TPGGames"
import JolliPlay from "./modules/promotions/JolliPlay"
import RecoveryBonus from "./modules/promotions/RecoveryBonus"
import JolliPlayCampaign from "./modules/promotions/JolliPlayCampaign"
import PragmaticZombieSchool from "./modules/promotions/PragmaticZombieSchool"
import FCGrandSpinAle from "./modules/promotions/FCGrandSpinAle"
import LuckyDraw from "./modules/promotions/LuckyDraw"
import PragmaticPlayDailyTourna from "./modules/promotions/PragmaticPlayDailyTourna"
import PGGlobalCash from "./modules/promotions/PGGlobalCash"
import FlexiSpinShowdown from "./modules/promotions/FlexiSpinShowdown"
import CQ9DoubleGrandGift from "./modules/promotions/CQ9DoubleGrandGift"
import RecoveryHour from "./modules/promotions/RecoveryHour"
import RecoveryHourPopup from "./modules/promotions/promotion_modules/RecoveryHourPopup"
import TPGRiseOfHellFire from "./modules/promotions/TPGRiseOfHellFire"
import FortuneDrops from "./modules/promotions/FortuneDrops"
import BNGPrizeDrop from "./modules/promotions/BNGPrizeDrop"
import AppPromo from "./modules/AppPromo"
import GreatSpinsOfFortune from "./modules/promotions/GreatSpinsOfFortune"
import LoveMagicSpin from "./modules/promotions/LoveMagicSpin"
import CQ9KingOfBetting from "./modules/promotions/CQ9KingOfBetting"
import RaceOfReels from "./modules/promotions/RaceOfReels"
import BNGSplash from "./modules/promotions/BNGSplash"
import { LeaderboardProviderBNG } from "./modules/data/LeaderboardProviderBNG"
import JellyExpress from "./modules/promotions/JellyExpress"
import GatesOfHades from "./modules/promotions/GatesOfHades"
import GatesOfOlympus from "./modules/promotions/GatesOfOlympus"

// Private Route Component - checks if user is logged in
function PrivateRoute({ element }) {
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true"
  return isLoggedIn ? element : <Navigate to="/" replace />
}

// Routes Page Pathings
export const routes = [
  { path: "/", element: <App /> },
  { path: "/app-promotion", element: <AppPromo /> },
  { path: "*", element: <NotFound /> },
  { path: "/page-not-found", element: <NotFound /> },
  { path: "/profile", element: <PrivateRoute element={<Profile />} /> },
  { path: "/slots", element: <SlotsGames /> },
  { path: "/live-casino", element: <LiveGamesPage /> },
  { path: "/sportsbook", element: <Sportsbookpage /> },
  { path: "/android", element: <DownloadApp /> },
  { path: "/easter-egg", element: <EasterEggBunny /> },
  { path: "/vip", element: <VipLevels /> },
  { path: "/terms-and-conditions", element: <TNC /> },
  { path: "/about-us", element: <AboutUs /> },
  { path: "/responsible-gaming", element: <ResponsibleGaming /> },
  { path: "/promotion", element: <Promotions /> },
  { path: "/promotion/8-lucky-draw", element: <LuckyDraw /> },
  { path: "/promotion/tpg-games", element: <TPGGames /> },
  { path: "/promotion/king-of-betting", element: <CQ9KingOfBetting /> },
  { path: "/promotion/fortune-drops", element: <FortuneDrops /> },
  {
    path: "/promotion/pragmatic-zombie-school",
    element: <PragmaticZombieSchool />,
  },
  {
    path: "/promotion/bng-prize-drop",
    element: <BNGPrizeDrop />,
  },
  {
    path: "/promotion/jelly-express",
    element: <JellyExpress />,
  },
  {
    path: "/promotion/gates-of-olympus",
    element: <GatesOfOlympus />,
  },
  {
    path: "/promotion/pg-global-cash",
    element: <PGGlobalCash />,
  },
  { path: "/promotion/jdb-exclusive-promo", element: <JDBExclusivePromo /> },
  { path: "/promotion/sign-up-treat", element: <FGHSignUpTreat /> },
  { path: "/promotion/daily-wins", element: <DailyWins /> },
  { path: "/promotion/bng-splash", element: <BNGSplash /> },
  { path: "/promotion/race-to-riches", element: <RaceToRiches /> },
  { path: "/promotion/jolli-play", element: <JolliPlay /> },
  { path: "/promotion/tpg-rise-of-hell-fire", element: <TPGRiseOfHellFire /> },
  {
    path: "/promotion/jolliplay-exclusive-campaign",
    element: <JolliPlayCampaign />,
  },
  {
    path: "/promotion/fcgrand-spin-ale",
    element: <FCGrandSpinAle />,
  },
  { path: "/promotion/easter-egg", element: <EasterEgg /> },
  { path: "/promotion/spin-surprize", element: <SpinSurprize /> },
  { path: "/promotion/cq9-funalo", element: <CQ9Gaming /> },
  { path: "/promotion/cq9-christmas", element: <CQ9DoubleGrandGift /> },
  { path: "/promotion/pragmatic-play-daily", element: <PragmaticPlayDaily /> },
  { path: "/promotion/betsoft-lucky-wheel", element: <BETSOFTLuckyWheel /> },
  { path: "/promotion/recovery-bonus", element: <RecoveryBonus /> },
  { path: "/promotion/recovery-hour", element: <RecoveryHour /> },
  { path: "/promotion/bng-bet-race", element: <BNGBetRace /> },
  { path: "/promotion/race-of-reels", element: <RaceOfReels /> },
  { path: "/promotion/flexi-spin-showdown", element: <FlexiSpinShowdown /> },
  {
    path: "/promotion/vip-rolling-commission",
    element: <ExlusiveVIPRollingCommission />,
  },
  {
    path: "/promotion/double-up-challenge",
    element: <DoubleUp />,
  },
  { path: "/promotion/2-30-lottery-draw", element: <LotteryDraw /> },
  { path: "/promotion/pera-o-bayong", element: <PeraOBayong /> },
  {
    path: "/promotion/pragmatic-play-daily-tournament",
    element: <PragmaticPlayDailyTourna />,
  },
  {
    path: "/promotion/new-member-bonus",
    element: <NewMemberPackageBonus />,
  },
  {
    path: "/promotion/third-time-charm-deposit-bonus",
    element: <ThirdTimeACharm />,
  },
  {
    path: "/promotion/agent-monthly-commission",
    element: <BecomeAgentMonthlyCommission />,
  },
  { path: "/promotion/vip-weekly-rewards", element: <VVIPWeeklyRewards /> },
  { path: "/promotion/vip-referral-program", element: <VIPReferralProgram /> },
  { path: "/promotion/weekly-cashback", element: <WeeklyCashback /> },
  { path: "/promotion/birthday-bonus", element: <BirthdayBonus /> },
  { path: "/promotion/payday-bonus", element: <PaydayBonus /> },
  {
    path: "/promotion/tpg-great-spins-of-fortune",
    element: <GreatSpinsOfFortune />,
  },
  { path: "/promotion/love-magic-spin", element: <LoveMagicSpin /> },
]
// IMPORTANT: All internal links must exclude trailing slashes.
// Example: Use /promotion/title, NOT /promotion/title/
// Applies site-wide — consistency prevents SEO and duplicate content issues.

function RootContent() {
  const { showMysteryFridayBtn, username } = useGlobalContext()
  const [activeModal, setActiveModal] = useState("")
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [showRecoveryPopup, setShowRecoveryPopup] = useState(true)
  const [showCountdown, setShowCountdown] = useState(false)

  useEffect(() => {
    const loggedIn = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedIn)
  }, [])

  // Mystery Friday Modal logic (unchanged)
  useEffect(() => {
    if (!isLoggedIn) return

    const now = new Date()
    const day = now.getDay()
    const hour = now.getHours()
    const minute = now.getMinutes()

    const isFriday = day === 5 && (hour > 13 || (hour === 13 && minute >= 0))
    const isSaturday = day === 6
    const isSunday = day === 0
    const isMonday = day === 1 && (hour < 24 || (hour === 23 && minute <= 59))

    const isWithinTimeRange = isFriday || isSaturday || isSunday || isMonday

    if (isWithinTimeRange && showMysteryFridayBtn) {
      setActiveModal("Pera O Bayong")
    }
  }, [showMysteryFridayBtn, username, isLoggedIn])

  const modalComponents = {
    "Pera O Bayong": ModulesPeraBayong,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null

  // Validation Session Code
  useEffect(() => {
    const checkSessionValidity = async () => {
      const sessionId = localStorage.getItem("sessionId")

      if (!username || !sessionId) return

      try {
        const url = `${apiJSONURL}?cmd=validateSession&u=${username}&session=${sessionId}`
        const response = await fetch(url)

        if (!response.ok) {
          throw new Error(`HTTP status ${response.status}`)
        }

        const data = await response.json()

        if (data?.isSessionValid === false) {
          handleLogout()
          alert(
            "For your security, you have been automatically logged out. Please log in again to continue."
          )
        }
      } catch (error) {
        console.error("[Session Check] Error validating session:", error)
      }
    }

    checkSessionValidity()

    // Optional: check session every 10 mins
    const intervalId = setInterval(checkSessionValidity, 10000)

    return () => clearInterval(intervalId)
  }, [username])
  //End Validation Session Code

  // useEffect(() => {
  //   const updateCountdown = () => {
  //     const now = new Date()

  //     // Define today's 8PM and 12MN
  //     const today8PM = new Date(now)
  //     today8PM.setHours(20, 0, 0, 0) // 8:00:00 PM

  //     const today12PM = new Date(now)
  //     today12PM.setHours(24, 0, 0, 0) // 12:00:00 MN

  //     // Check if current time is between 8PM and 9MN
  //     if (now >= today8PM && now < today12PM) {
  //       setShowCountdown(true)
  //     } else {
  //       setShowCountdown(false)
  //     }
  //   }

  //   updateCountdown()
  // }, [])

  // ✅ Disable page scroll when popup is open

  useEffect(() => {
    document.body.style.overflow = activeModal ? "hidden" : "auto"
    return () => {
      document.body.style.overflow = "auto"
    }
  }, [activeModal])

  const location = useLocation()
  const isAppPromotion = location.pathname === "/app-promotion"

  return (
    <>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal("")} />}

      <main className="main-container all-p age-main-container-min-height">
        {!isAppPromotion && (
          <>
            <TopHeaderNav />
            <div className="search-bar-homepage">
              <SearchGamesLibrary />
            </div>
          </>
        )}

        <div className="main-body main-container-global-adjusted-padding">
          {!isAppPromotion && <MainNav />}
          <div className="main-body-section">
            <Routes>
              {routes.map((route, index) => (
                <Route key={index} path={route.path} element={route.element} />
              ))}
            </Routes>

            {!isAppPromotion && <SideContainer />}
          </div>
          {!isAppPromotion && (
            <>
              <Footer />
              <FeaturedPromoMobile />
              <LiveChat />
            </>
          )}
        </div>
      </main>
    </>
  )
}

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(
  <GlobalProvider>
    <LeaderboardProvider>
      <LeaderboardProviderBNG>
        <LeaderboardProviderCQ9>
          <LeaderboardProviderPP>
            12345t7456231
            <BrowserRouter>
              <RootContent />
            </BrowserRouter>
          </LeaderboardProviderPP>
        </LeaderboardProviderCQ9>
      </LeaderboardProviderBNG>
    </LeaderboardProvider>
  </GlobalProvider>
)
